<template>
  <header
    class="gap-6 items-center px-4 mx-auto max-w-screen-xl flex flex-col justify-center lg:px-6"
  >
    <div class="font-light text-gray-500 sm:text-lg">
      <div class="mb-4 grid lg:grid-cols-3 gap-4 grid-cols-1">
        <div
          v-if="isLoading"
          class="text-center mx-auto col-span-full flex flex-col items-center justify-center"
        >
          <Loader2 class="h-16 w-16 text-gray-400 mb-4 animate-spin" />
          <h3 class="text-2xl font-semibold text-gray-900 mb-2">
            Lade Neuigkeiten...
          </h3>
          <p class="text-sm text-gray-500 mb-2 max-w-lg">
            Bitte warten Sie, während die neuesten Beiträge geladen werden. Dies
            kann einen Moment dauern, je nach Internetverbindung und Anzahl der
            Beiträge.
          </p>
        </div>
        <div
          v-else-if="posts.length !== 0"
          @click="openModal(post)"
          v-for="(post, index) in posts.slice(0, length)"
          :key="index"
          class="p-4 rounded-lg shadow-lg bg-gray-100 border-gray-200 border flex flex-col items-start cursor-pointer transition"
        >
          <img
            :src="$pb.files.getURL(post, post.image)"
            :alt="`Bild von ${post.title}`"
            class="h-60 w-full object-cover rounded-lg mb-3"
          />
          <h3 class="text-2xl font-semibold text-gray-900 mb-2">
            {{ post.title }}
          </h3>
          <h4 class="text-sm text-gray-500 mb-2">
            <span
              v-html="
                post.content.slice(0, 100) +
                (post.content.length > 100 ? '...' : '')
              "
            ></span>
          </h4>
        </div>
        <div
          v-else
          class="text-center mx-auto col-span-full flex flex-col items-center justify-center"
        >
          <TextSearchIcon class="h-16 w-16 text-gray-400 mb-4" />
          <h3 class="text-2xl font-semibold text-gray-900 mb-2">
            Keine Neuigkeiten verfügbar
          </h3>
          <p class="text-sm text-gray-500 mb-2">
            Momentan gibt es keine neuen Beiträge. Bitte schauen Sie später
            wieder vorbei.
          </p>
        </div>
      </div>
    </div>
  </header>

  <!-- Overlay -->
  <div
    v-if="modalOpen"
    class="fixed inset-0 z-50 flex items-center justify-center p-4"
  >
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50" @click="closeModal"></div>

    <!-- Modal content -->
    <div
      class="relative bg-white rounded-xl shadow-xl max-w-7xl w-full max-h-[90vh] overflow-y-auto z-10"
    >
      <div class="sticky top-0 bg-white p-6">
        <button
          class="absolute top-4 right-4 text-gray-400 hover:text-black text-2xl"
          @click="closeModal"
          aria-label="Schließen"
        >
          <XIcon class="h-7 w-7" />
        </button>
      </div>

      <div v-if="selectedPost" class="p-6">
        <h2 class="text-4xl font-bold mb-2 text-text-heading">
          {{ selectedPost.title }}
        </h2>
        <div class="text-gray-500 mb-4">
          {{ formatDate(selectedPost.created) }}
          <span v-if="selectedPost.author"> · {{ selectedPost.author }}</span>
        </div>
        <div
          v-html="selectedPost.content"
          class="prose max-w-none text-body"
        ></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Loader2, TextSearchIcon, XIcon } from "lucide-vue-next";

const { posts, isLoading } = usePosts();
const selectedPost = ref<any | null>(null);
const modalRef = ref<HTMLDialogElement | null>(null);
const modalOpen = ref(false);
const { $pb } = useNuxtApp();

defineProps<{ length?: number }>();

function formatDate(date: string) {
  return new Date(date).toLocaleDateString("de-DE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function openModal(post: any) {
  selectedPost.value = post;
  modalOpen.value = true;
  if (modalRef.value) {
    modalRef.value.showModal();
  }
  document.body.style.overflow = "hidden";
}

function closeModal() {
  if (modalRef.value) {
    modalRef.value.close();
  }
  modalOpen.value = false;
  document.body.style.overflow = "";
}
</script>
